import { useContext, useMemo } from "react";
import dayjs from "dayjs";
import parse, { domToReact } from "html-react-parser";
import OsteopataContext from "../../context/osteopata";
import UserContext from "../../context/user";
import Icon from "../icon";

const OsteopataBoxWrapper = () => {
  const { userProfile } = useContext(UserContext);
  const { labels, currentRequest, appLang, setNavigation } = useContext(OsteopataContext);

  const parsedLabel = useMemo(() => {
    const opt = {
      replace: (elem) => {
        if (elem.type === "tag" && elem.name === "a") {
          return (
            <button className="link link--accent" onClick={() => setNavigation("info")}>
              {domToReact(elem.children)}
            </button>
          );
        }
      },
    };

    return parse(
      labels?.WELFARE_OSTEOPATA_BOX_GO_TO_INFO ||
        `<div class="box-wrapper__link">Per le modalità di pagamento consulta la <a href="info">pagina informativa del servizio</a>.</div>`,
      opt
    );
  }, [labels, setNavigation]);

  return (
    <div className="box-wrapper">
      <div className="box-wrapper__box">
        <h2 className="box-wrapper__caption">
          {labels?.WELFARE_CART_BOX_YOUR_DATA || "I tuoi dati"}
        </h2>
        <div className="box-wrapper__profile">
          <span
            className="box-wrapper__info"
            translate="no"
          >{`${userProfile?.firstName} ${userProfile?.lastName}`}</span>
          <div className="box-wrapper__info" data-label="WELFARE_CHECKUP_BOX_PHONE">
            {labels?.WELFARE_CHECKUP_BOX_PHONE}: <span>{currentRequest.welfarePhone || "-"}</span>
          </div>
          <div className="box-wrapper__info" data-label="WELFARE_CHECKUP_BOX_MAIL">
            {labels?.WELFARE_CHECKUP_BOX_MAIL}: <span>{currentRequest.welfareEmail || "-"}</span>
          </div>
        </div>
      </div>
      <div className="box-wrapper__box">
        <h2 className="box-wrapper__caption">
          {labels?.WELFARE_OSTEOPATA_BOX_OSTEOPATA || "L'osteopata"}
        </h2>
        <div className="box-wrapper__profile">
          <span className="box-wrapper__info">{currentRequest?.osteopath?.name}</span>
        </div>
        <div className="box-wrapper__profile">
          <span className="box-wrapper__info box-wrapper__info--osteopath-price">
            <Icon name="money" className="money" />
            {currentRequest?.osteopath?.price}
          </span>
          {parsedLabel}
        </div>
      </div>
      <div className="box-wrapper__box">
        <h2 className="box-wrapper__caption">
          {labels?.WELFARE_OSTEOPATA_BOX_BOOKING || "Appuntamento"}
        </h2>
        <div className="box-wrapper__profile">
          <div className="box-wrapper__info" data-label="WELFARE_OSTEOPATA_BOX_DATE">
            {labels?.WELFARE_OSTEOPATA_BOX_DATE}:{" "}
            <span>
              {dayjs(Number(currentRequest.bookingDate)).locale(appLang?.value).format("LL")}
            </span>
          </div>
          <div className="box-wrapper__info" data-label="WELFARE_OSTEOPATA_BOX_TIME">
            {labels?.WELFARE_OSTEOPATA_BOX_TIME}:{" "}
            <span>
              {dayjs(Number(currentRequest.bookingDate)).locale(appLang?.value).format("HH:mm")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const OsteopataRecap = ({ setCancelAppointmentModal }) => {
  const { labels, currentRequest, setCurrentRequest } = useContext(OsteopataContext);

  const handleEdit = () => {
    setCurrentRequest((current) => ({ ...current, editMode: true }));
  };

  const handleCancel = () => setCancelAppointmentModal(currentRequest);

  return (
    <div className="wrapper wrapper--app wrapper-small">
      {currentRequest?.status === "CANCELLED_BY_OSTEOPATH" && currentRequest?.cancellationNotes && (
        <div className="osteopata-content__cancellation">
          <Icon name="message" />
          <strong>{currentRequest?.cancellationNotes}</strong>
        </div>
      )}
      <OsteopataBoxWrapper />
      <div className="form__buttons-wrapper form__buttons-wrapper--static">
        {currentRequest?.status === "BOOKED" &&
          dayjs().isBefore(dayjs(Number(currentRequest?.bookingDate))) && (
            <div className="form__buttons form__buttons--center">
              <button className="button secondary form__submit" onClick={handleEdit}>
                {labels?.WELFARE_EDIT || "Modifica"}
                <Icon name="pencil" />
              </button>
              <button className="button primary form__submit" onClick={handleCancel}>
                {labels?.WELFARE_OSTEOPATA_DISCARD || "Disdici"}
                <Icon name="calendar-xmark" />
              </button>
            </div>
          )}
      </div>
    </div>
  );
};

export default OsteopataRecap;
